import axios from "axios";
import config from "@/../config";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import router from "@/router";

import pinia from "@/stores";
import { useGeneralStore } from "@/stores/general";

const apiClient = axios.create({
  baseURL: config.api_base_url_stg,
  headers: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  },
  params: {
    time: new Date().getTime(),
  },
});

// attach token and trigger loader
apiClient.interceptors.request.use(
  (config) => {
    if (config.showLoader !== false) {
      try {
        const generalStore = useGeneralStore(pinia);
        generalStore.ShowLoading();
      } catch (e) {
        console.error("Error in request interceptor (loading):", e);
      }
    }

    const token = localStorage.getItem("user_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    if (error.config?.showLoader !== false) {
      try {
        const generalStore = useGeneralStore(pinia);
        generalStore.HideLoading();
      } catch (e) {
        console.error("Error in request error interceptor (loading):", e);
      }
    }
    return Promise.reject(error);
  },
);

// global error toast and hide loader
apiClient.interceptors.response.use(
  (response) => {
    if (response.config?.showLoader !== false) {
      try {
        // const generalStore = useGeneralStore(pinia);
        // generalStore.HideLoading();
      } catch (e) {
        console.error("Error in response interceptor (loading):", e);
      }
    }
    return response;
  },
  (error) => {
    if (error.config?.showLoader !== false) {
      try {
        // const generalStore = useGeneralStore(pinia);
        // generalStore.HideLoading();
      } catch (e) {
        console.error("Error in response error interceptor (loading):", e);
      }
    }

    if (error.response?.status === 401) {
      console.warn("[API] Global 401 handler: Token is invalid or expired.");

      // Clear token
      localStorage.removeItem("user_token");

      // Redirect to login if not already there
      if (router.currentRoute.value.path !== "/login") {
        router.push({ path: "/login", query: { unauthorized: 1 } });
      }
    }

    const msg =
      error.response?.data?.msg ||
      error.response?.data?.message ||
      "Unexpected error";

    toast.error(msg);

    return Promise.reject(error);
  },
);

export default apiClient;
